function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { CSSTransition } from 'react-transition-group';
import { useMachine } from '@minutemailer/state';
import ui from "../../ui";
import classes from "../../../design-system/scss/components/modal.module.scss";
import backdropClasses from "../../../design-system/scss/components/backdrop.module.scss";
import Backdrop from "../Backdrop";
import Portal from "./Portal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var backdropStages = {
  enter: backdropClasses.enter,
  enterActive: backdropClasses['enter-active'],
  exit: backdropClasses.exit,
  exitActive: backdropClasses['exit-active']
};
var modalStages = {
  enter: classes.enter,
  enterActive: classes['enter-active'],
  exit: classes.exit,
  exitActive: classes['exit-active']
};
var Modal = function Modal() {
  var _useMachine = useMachine(ui, null, ['modal', 'current']),
    _useMachine2 = _slicedToArray(_useMachine, 2),
    _useMachine2$ = _useMachine2[0],
    modal = _useMachine2$.modal,
    current = _useMachine2$.current,
    machine = _useMachine2[1];
  var modalClosed = function modalClosed() {
    if (typeof modal.onClose === 'function') {
      modal.onClose();
    }
    machine.modalClosed({
      modal: null
    });
  };
  return /*#__PURE__*/_jsxs(Portal, {
    children: [/*#__PURE__*/_jsx(CSSTransition, {
      "in": current === 'displaying-modal' || current === 'modal-locked',
      unmountOnExit: true,
      timeout: 300,
      classNames: modalStages,
      onExited: modalClosed,
      children: /*#__PURE__*/_jsx("div", {
        role: "dialog",
        "aria-modal": "true",
        className: classes['c-modal'],
        children: /*#__PURE__*/_jsx("div", {
          className: classes['c-modal__view'],
          children: modal && modal.content
        })
      })
    }), /*#__PURE__*/_jsx(CSSTransition, {
      "in": current === 'displaying-modal' || current === 'modal-locked',
      unmountOnExit: true,
      timeout: 300,
      classNames: backdropStages,
      children: /*#__PURE__*/_jsx(Backdrop, {
        background: true,
        closeIcon: true,
        onClick: machine.closeModal
      })
    })]
  });
};
export default Modal;